import React from "react";
import Image from "next/image";
import Link from "next/link";
import { Button } from "../Button/Button";
export const ThoughtLeadershipCard = ({ image, date, title, slug }) => {
    return (
        <Link
            href={`/thought-leadership/${slug}`}
            className="border-b border-[#D9D9D9]"
        >
            <div className="flex flex-col md:flex-row gap-4 justify-between py-5 xl:p-8 items-start md:items-center">
                {/* {image ? (
                    <Image
                        alt="Image"
                        src={image}
                        width={30}
                        height={30}
                        unoptimized
                        className="object-cover h-[200px] md:h-[130px] w-full md:w-[150px] xl:w-[240px] rounded-[20px] flex-shrink-0"
                    />
                ) : (
                    <div className="w-full  h-[200px] md:h-[130px] md:w-[150px] xl:w-[240px] rounded-[20px] bg-blue flex-shrink-0"></div>
                )} */}
                <div className="flex gap-8 2xl:gap-24 items-start flex-grow justify-between md:justify-normal w-full">
                    <span className="text-[14px] lg:text-[16px] xl:text-[18px] font-bold text-text order-2 md:order-1 flex-shrink-0 w-[100px]">
                        {date}
                    </span>
                    <h3 className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal leading-[24px] lg:leading-[30px] 2xl:w-[70%] order-1 md:order-2 ">
                        {title}
                    </h3>
                </div>
                <div className="flex-shrink-0">
                    <span className="bg-primary text-white px-6 py-2 rounded-full">
                        Read More
                    </span>
                </div>
            </div>
        </Link>
    );
};
